import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'sticky',
    top: ({ top }) => top || 60,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(1, 2, 1, 0.5),
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E0E0E0',
    zIndex: 10000,
  },
  dismissButton: {
    flexShrink: 0,
    width: 44,
    height: 44,
    padding: 0,
    color: theme.palette.text.secondary,
    '& svg': {
      width: 20,
      height: 20,
    },
  },
  appIcon: {
    flexShrink: 0,
    width: 48,
    height: 48,
    borderRadius: 12,
    border: '1px solid #E0E0E0',
    objectFit: 'cover',
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  titleText: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
  },
  subtitleText: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    lineHeight: '16px',
  },
  ctaButton: {
    flexShrink: 0,
    minHeight: 36,
    padding: theme.spacing(0.5, 2.5),
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
}))

export default useStyles
